'use client';
import dynamic from 'next/dynamic';

const ShareEvent = dynamic(() => import('./shareEvent.component'), {
  ssr: false,
});

export { ShareEvent };
